import { Product } from './Product'
import { Field, ObjectType, Float, InputType } from 'type-graphql'

/**
 * Represents a parent product that uses the current product in its bill of materials.
 * Used to display "Used In" relationships showing where a product is used as a sub-component.
 */
@ObjectType()
@InputType('ProductUsedInInput')
export class ProductUsedIn {
  @Field(() => Product)
  parentProduct: ReturnType<() => Product>

  @Field(() => Float)
  quantity: number

  @Field(() => Boolean)
  requiredToBuild: boolean
}
